import React from 'react';
import { ASSESSMENT } from '../../assets/asset';

export function PopupFail({ onRetry }) {
  return (
    <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-50 p-4">
      <div className="flex flex-col items-center w-full max-w-[40%] md:max-w-sm">
        <img
          src={ASSESSMENT.failPopup}
          alt="Assessment Failed"
          className="w-full h-auto object-contain rounded-md "
        />
        <img
          src={ASSESSMENT.retry}
          alt="Retry Button"
          className="cursor-pointer w-14 md:w-16 mt-3 hover:scale-105 transition md:min-h-20 md:min-w-20"
          onClick={onRetry}
        />
      </div>
    </div>
  );
}

export function PopupPass({ onContinue }) {
  return (
    <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-50 p-4">
      <div className="flex flex-col items-center w-full max-w-xs sm:max-w-sm">
        <img
          src={ASSESSMENT.passPopup}
          alt="Assessment Passed"
          className="w-full h-auto object-contain rounded-md"
        />
        <img
          src={ASSESSMENT.continue}
          alt="Continue Button"
          className="cursor-pointer w-14 sm:w-16 mt-3 hover:scale-105 transition min-w-44"
          onClick={onContinue}
        />
      </div>
    </div>
  );
}

export default {
  PopupFail,
  PopupPass,
};
